import { useEffect, useState } from "react";
import { Box, Card, CircularProgress, Divider, TableBody, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import Paginator from "../../../toolkit/Paginator";
import RightArrowOpen from "../../../icons/RightArrowOpen.svg";
import Edit from "../../../icons/edit.svg";
import Trash from "../../../icons/trash1.svg";
import Restoreicon from "../../../icons/Restoreicon.svg";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import axios from "../../../utils/fvAxios";
import BaseUrl from "../../../utils/base-uri.json";
import { isArray } from "lodash";
import _ from "lodash";
import LoadingSpinner from "../../../toolkit/LoadingSpinner";
import ErrorAlert from "../../../toolkit/ErrorAlert";
import { FormatToLocalTimeString } from "../../../utils/dateFormat";
import GetfVDateFormate from "../../../utils/Genaricfunctions";
import {
  KeyboardArrowDown,
  KeyboardArrowUp,
  UnfoldMore,
} from "@mui/icons-material";

const queryUrl = BaseUrl.baseUrl + BaseUrl.OnsiteOffsite.GetVisitorsCheckin;
const pageSize = 10;

const toQueryString = (obj) => {
  return "?".concat(
    Object.keys(obj)
      .map((e) => {
        if (isArray(obj[e])) {
          var d = obj[e]?.map(
            (r, idx) => `${e}[${idx}]=${encodeURIComponent(r)}`
          );
          return d.join("&");
        }
        return obj[e]
          ? `${encodeURIComponent(e)}=${encodeURIComponent(obj[e])}`
          : null;
      })
      .filter((e) => !!e)
      .join("&")
  );
};

const getUrl = (url, data) => `${url}${toQueryString(data)}`;

export default function VendorEmployees({ businessUnitId, locationId }) {
  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.action.hover,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
    // hide last border
    "&:last-child td, &:last-child th": {
      border: 0,
      marginBottom: "20px",
    },
  }));
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const [pageCount, setPageCount] = useState(1);
  const [pageNumber, setPageNumber] = useState(1);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [refresh, setRefresh] = useState(true);
  const [searchValue, setSearchValue] = useState("");
  const [visitors, setVisitors] = useState("");
  const [isDeleting, setIsDeleting] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [isReseting, setIsReseting] = useState(false);
  const [visitorId, setVisitorId] = useState(null);
  const [visitorFirstName, setVisitorFirstName] = useState("");
  const [visitorLastName, setVisitorLastName] = useState("");
  const [visitorCompany, setVisitorCompany] = useState("");
  const [visitorSiteContact, setVisitorSiteContact] = useState("");
  const [openAddEditVisitorDialog, setOpenAddEditVisitorDialog] = useState(false);
  const [checkinDialogOpen, setCheckinDialogOpen] = useState(false);
  const [id, setID] = useState("");
  const [tagNumber, setTagNumber] = useState(undefined);
  const [badgeNumber, setBadgeNumber] = useState(undefined);
  const [isTagNumberExists, setisTagNumberExists] = useState(false);
  const [isBadgeNumberExists, setIsBadgeNumberExists] = useState(false);
  const [firstNameError, setFirstNameError] = useState("");
  const [lastNameError, setLastNameError] = useState("")
  const [companyNameError, setCompanyNameError] = useState("")
  const [siteNameError, setSiteNameError] = useState("")
  const [permissions, setPermissions] = useState({
    hasTagPermission: false,
    hasBadgePermission: false,
  });

  const [selectedVendor, setSelectedVendor] = useState({
    vendorId: null,
    empId: null,
  });
  const [orderBy, setOrderBy] = useState({
    sortingColumn: "VisitorName",
    sortAscending: true,
  });

  const [paramsState, setParamsState] = useState({
    buId: businessUnitId,
    locId: locationId,
    pageSize: 10,
    pageNumber: pageNumber,
    orderBy: orderBy.sortingColumn,
    sortOrder: orderBy.sortAscending ? "ASC" : "DESC",
    searchValue: searchValue,
  });

  const sortTable = (sortingColumn) => {
    if (orderBy.sortingColumn === sortingColumn) {
      setOrderBy((prev) => ({
        ...prev,
        sortAscending: !orderBy.sortAscending,
      }));
    } else {
      setOrderBy({
        sortingColumn,
        sortAscending: true,
      });
    }
  };
  useEffect(() => {
    setParamsState((prev) => ({
      ...prev,
      orderBy: orderBy.sortingColumn,
      sortOrder: orderBy.sortAscending ? "ASC" : "DESC",
    }));
    setRefresh(true);
  }, [orderBy]);

  const setPage = (pageNumber) => {
    if (pageNumber > 0) {
      setPageNumber(pageNumber);
      setParamsState((prev) => ({ ...prev, pageNumber }));
      setRefresh(true);
    }
  };

  useEffect(() => {
    if (refresh) {
      setLoading(true);
      const url = getUrl(queryUrl, { ...paramsState });
      axios
        .get(url)
        .then((res) => {
          const data = res?.data?.data?.sanitizedResult;
          setPageCount(Math.ceil((res?.data?.count || pageSize) / pageSize));
          setVisitors(data);
          setPermissions({
            hasTagPermission: res?.data?.data?.hasPermission,
            hasBadgePermission: res?.data?.data?.hasBadgePermission,
          });
        })
        .catch((err) => setError(err))
        .finally(() => {
          setLoading(false);
          setRefresh(false);
        });
    }
  }, [paramsState, refresh]);

  const handleCheckinOpen = (vendorId, empId, tagNumber, badgeNumber) => {
    // if (tagNumber) {
    //   setisTagNumberExists(true);
    // } else {
    //   setisTagNumberExists(false);
    // }

    // if (badgeNumber) {
    //   setIsBadgeNumberExists(true);
    // } else {
    //   setIsBadgeNumberExists(false);
    // }

    setTagNumber(tagNumber);
    setBadgeNumber(badgeNumber);
    setCheckinDialogOpen(true);
    setSelectedVendor({ vendorId, empId });
  };

  const checkinVisitorDirectly = (vendorId, empId, tagNumber, badgeNumber) => {
    const data = {
      vendorEmployeeID: empId,
      vendorID: vendorId,
      clientBusinessUnitID: businessUnitId,
      clientBusinessUnitSiteID: locationId,
      tagNumber: tagNumber,
      badgeNumber: badgeNumber,
      userType: 1,
    };
    axios
      .post(BaseUrl.baseUrl + BaseUrl.OnsiteOffsite.CheckInVisitor, data)
      .then((resp) => {
        if (resp?.data?.data === "Success") {
          setRefresh(true);
        }
      });
  };


  const handleCheckinDialogClose = () => {
    setCheckinDialogOpen(false);
    setSelectedVendor({
      vendorId: null,
      empId: null,
    });
    setTagNumber(undefined);
    setBadgeNumber(undefined);
  };
  const changeTagNumber = (value) => {
    const numericInput = value.replace(/[^0-9]/g, "");
    if (numericInput.length <= 4) setTagNumber(numericInput);
    else setTagNumber(numericInput.substring(0, 4));
  };

  const changeBadgeNumber = (value) => {
    const numericInput = value.replace(/[^0-9]/g, "");
    if (numericInput.length <= 4) setBadgeNumber(numericInput);
    else setBadgeNumber(numericInput.substring(0, 4));
  };

  const checkinVisitor = () => {

    const { vendorId, empId } = selectedVendor;
    const data = {
      vendorEmployeeID: empId,
      vendorID: vendorId,
      clientBusinessUnitID: businessUnitId,
      clientBusinessUnitSiteID: locationId,
      tagNumber: tagNumber,
      badgeNumber: badgeNumber,
      userType: 1,
    };
    axios
      .post(BaseUrl.baseUrl + BaseUrl.OnsiteOffsite.CheckInVisitor, data)
      .then((resp) => {
        if (resp?.data?.data === "Success") {
          setRefresh(true);
        }
      })
      .finally(() => {
        handleCheckinDialogClose();
      });
  };

  const handleClickOpen = (num) => {
    setID(num);
    setOpenAddEditVisitorDialog(true);
  };

  const editVisitorDetail = (
    firstName,
    lastName,
    company,
    siteContact,
    employeeID
  ) => {
    setVisitorFirstName(firstName);
    setVisitorLastName(lastName);
    setVisitorCompany(company);
    setVisitorSiteContact(siteContact);
    setVisitorId(employeeID);
    handleClickOpen(2);
  };

  const handleAddEditDialogClose = () => {
    setVisitorFirstName("");
    setVisitorLastName("");
    setVisitorCompany("");
    setVisitorSiteContact("");
    setVisitorId(null);
    setOpenAddEditVisitorDialog(false);
    setLastNameError("");
    setFirstNameError("");
    setSiteNameError("");
    setCompanyNameError("");
  };

  useEffect(() => {
    setParamsState((prev) => ({
      ...prev,
      buId: businessUnitId,
      locId: locationId,
    }));
    setRefresh(true);
  }, [locationId]);

  const debouncedSearch = _.debounce((value) => {
    setParamsState((prev) => ({
      ...prev,
      searchValue: value,
      pageNumber: 1,
    }));
    setRefresh(true);
  }, 1000);

  const changeSearchValue = (value) => {
    if (searchValue !== value) {
      setSearchValue(value);
      debouncedSearch(value);
    }
  };
  const handleDeleteDialogClose = () => {
    setDeleteDialogOpen(false);
    setVisitorId(null);
    setIsDeleting(false);
  };

  const deleteVisitor = () => {
    setIsDeleting(true);
  
    axios
      .post(
        BaseUrl.baseUrl + BaseUrl.OnsiteOffsite.DeleteVisitor + visitorId,
        {}
      )
      .then((resp) => {
        if (resp?.data?.data === "Success") {
          setRefresh(true);
        }
      })
      .finally(() => {
        handleDeleteDialogClose();
      });
  };

  const handleResetVisitor = (onsiteOffsiteId) => {
    setIsReseting(true);
    axios
      .post(
        BaseUrl.baseUrl + BaseUrl.OnsiteOffsite.ResetVisitor + onsiteOffsiteId,
        {}
      )
      .then((resp) => {
        if (resp?.data?.data === "Success") {
          setRefresh(true);
        }
      })
      .finally(() => {
        setIsReseting(false);
      });
  };

  const handleCheckoutUser = (vendorId, empId, onsiteOffsiteID) => {
    const data = {
      onsiteOffsiteID: onsiteOffsiteID,
      vendorEmployeeID: empId,
      vendorID: vendorId,
      clientBusinessUnitID: businessUnitId,
      clientBusinessUnitSiteID: locationId,
    };
    axios
      .post(BaseUrl.baseUrl + BaseUrl.OnsiteOffsite.CheckoutVisitor, data)
      .then((resp) => {
        if (resp?.data?.data === "Success") {
          setRefresh(true);
        }
      });
  };

  const handleSaveVisitor = () => {
    setIsSaving(true);
    if (validData(visitorFirstName, visitorLastName)) {
      const localVisitors = {
        visitorId: visitorId,
        firstName: visitorFirstName,
        lastName: visitorLastName,
        company: visitorCompany,
        siteContact: visitorSiteContact,
        ClientBusinessUnitID: businessUnitId,
        ClientBusinessUnitSiteID: locationId,
      };

      axios
        .post(BaseUrl.baseUrl + BaseUrl.OnsiteOffsite.SaveVisitor, localVisitors)
        .then((resp) => {
          if (resp?.data?.data === "Success") {
            setParamsState((prev) => ({
              ...prev,
              pageNumber: 1,
            }));
            setRefresh(true);
          }
        })
        .finally(() => {
          handleAddEditDialogClose();
          setIsSaving(false);
        });
    }

  };

  const changeFirstName = (value) => {
    setVisitorFirstName(value);
    if (value === null || value == "") {
      setFirstNameError("Please enter first name");
    }
    else if (value.length > 50) {
      setFirstNameError("Max 50 character allowed");
    }
    else {
      setFirstNameError(null)
    }
  }
  const changeLastName = (value) => {
    setVisitorLastName(value);
    if (value === null || value == "") {
      setLastNameError("Please enter last name");
    }
    else if (value.length > 50) {
      setLastNameError("Max 50 character allowed");
    }
    else {
      setLastNameError(null)
    }
  }
  const changeCompany = (value) => {
    setVisitorCompany(value);
    if (value !== null && value.length > 100) {
      setCompanyNameError("Max 100 character allowed");
    }
    else {
      setCompanyNameError(null)
    }
  }
  const changeSiteContact = (value) => {
    setVisitorSiteContact(value);
    if (value !== null && value.length > 250) {
      setSiteNameError("Max 250 character allowed");
    }
    else {
      setSiteNameError(null)
    }
  }

  const validData = (visitorFirstName, visitorLastName) => {
    let response = true;
    if (visitorFirstName === null || visitorFirstName == "" || visitorFirstName.length > 50) {
      setFirstNameError("Please enter first name");
      response = false;
    }

    if (visitorLastName === null || visitorLastName == "" || visitorLastName.length > 50) {
      setLastNameError("Please enter last name");
      response = false;
    }

    if (siteNameError || companyNameError) {
      response = false;
    }
    return response;
  }
  return (
    <>
      <Card>
        <Dialog
          fullScreen={fullScreen}
          open={openAddEditVisitorDialog}
          onClose={handleAddEditDialogClose}
        >
          <DialogContent sx={{ padding: "48px 48px" }}>
            <DialogTitle
              sx={{
                textAlign: "center",
                fontWeight: 500,
                fontSize: 20,
              }}
            >
              <span style={{ fontSize: "larger" }}>
                {id == 1 ? "Add New Visitor" : "Edit Visitor"}
              </span>
              <br></br>
            </DialogTitle>

            <DialogActions>
              <div>
                <div className="">
                  <div>
                    <span style={{ color: "#3E4A62" }}>First Name</span><span className="asterisk-red">*</span>
                    <br />
                    <TextField
                      placeholder="First Name"
                      sx={{
                        "& legend": { display: "none" },
                        "& fieldset": { top: 0 },
                        fontFamily: "Arial, FontAwesome",
                      }}
                      variant="outlined"
                      size="small"
                      value={visitorFirstName}
                      onChange={(e) => changeFirstName(e.target.value)}
                      required
                    />
                    {firstNameError
                      &&
                      <>
                        <br />
                        <Typography className='asterisk-red'>
                          {firstNameError}
                        </Typography>
                      </>
                    }
                  </div>

                  <div>
                    <span style={{ color: "#3E4A62" }}>Last Name</span><span className="asterisk-red">*</span>
                    <br />
                    <TextField
                      placeholder="Last Name"
                      sx={{
                        "& legend": { display: "none" },
                        "& fieldset": { top: 0 },
                        fontFamily: "Arial, FontAwesome",
                      }}
                      variant="outlined"
                      size="small"
                      value={visitorLastName}
                      onChange={(e) => changeLastName(e.target.value)}
                      required
                    />
                    {lastNameError
                      &&
                      <>
                        <br />
                        <Typography className='asterisk-red'>
                          {lastNameError}
                        </Typography>
                      </>
                    }
                  </div>
                  <div>
                    <span style={{ color: "#3E4A62" }}>Company</span>
                    <br />
                    <TextField
                      placeholder="Company"
                      sx={{
                        "& legend": { display: "none" },
                        "& fieldset": { top: 0 },
                        fontFamily: "Arial, FontAwesome",
                      }}
                      variant="outlined"
                      size="small"
                      value={visitorCompany}
                      onChange={(e) => changeCompany(e.target.value)}
                    />
                    {companyNameError
                      &&
                      <>
                        <br />
                        <Typography className='asterisk-red'>
                          {companyNameError}
                        </Typography>
                      </>
                    }
                  </div>
                  <div>
                    <span style={{ color: "#3E4A62" }}>Site Contact</span>
                    <br />
                    <TextField
                      placeholder="Site Contact"
                      sx={{
                        "& legend": { display: "none" },
                        "& fieldset": { top: 0 },
                        fontFamily: "Arial, FontAwesome",
                      }}
                      variant="outlined"
                      size="small"
                      value={visitorSiteContact}
                      onChange={(e) => changeSiteContact(e.target.value)}
                    />
                    {siteNameError
                      &&
                      <>
                        <br />
                        <Typography className='asterisk-red'>
                          {siteNameError}
                        </Typography>
                      </>
                    }
                  </div>
                </div>

                <DialogActions>
                  <div className="login-help__buttonContainer mt-4">
                    <Button
                      variant="contained"
                      className="login-help-button-cancel mx-2"
                      onClick={handleAddEditDialogClose}
                    >
                      Cancel
                    </Button>

                    <Button
                      variant="contained"
                      className="login-button-request mx-2"
                      onClick={handleSaveVisitor}
                      disabled={isSaving}
                    >
                      {id == 1 ? "Add " : "Save"}
                    </Button>
                  </div>
                </DialogActions>
              </div>
            </DialogActions>
          </DialogContent>
        </Dialog>

        <Dialog
          fullScreen={fullScreen}
          open={deleteDialogOpen}
          onClose={handleDeleteDialogClose}
        >
          <DialogTitle id="alert-dialog-title">
            {"Are you sure you want to delete?"}
          </DialogTitle>
          <DialogActions className="mx-3">
            <Button
              variant="contained"
              onClick={handleDeleteDialogClose}
              style={{ padding: "12px" }}
            >
              Cancel
            </Button>

            {isDeleting ? (
              <Box
                style={{
                  display: "flex",
                  marginLeft: "auto",
                  padding: "5px",
                }}
              >
                <CircularProgress size={28} />
              </Box>
            ) : (
              <Button
                variant="contained"
                onClick={deleteVisitor}
                style={{ marginLeft: "auto", padding: "12px" }}
              >
                Delete
              </Button>
            )}
          </DialogActions>
        </Dialog>

        <Dialog
          fullScreen={fullScreen}
          open={checkinDialogOpen}
          onClose={handleCheckinDialogClose}
        >
          <DialogContent sx={{ padding: "48px 48px" }}>
            <DialogTitle
              sx={{
                textAlign: "center",
                fontWeight: 500,
                fontSize: 20,
              }}
            ></DialogTitle>
            <DialogActions>
              <div>
                <div>
                  {permissions.hasTagPermission && <div>
                    <span style={{ color: "#3E4A62" }}>Tag Number </span>
                    <br />
                    <TextField
                      placeholder="Tag Number"
                      sx={{
                        "& legend": { display: "none" },
                        "& fieldset": { top: 0 },
                        fontFamily: "Arial, FontAwesome",
                      }}
                      variant="outlined"
                      size="small"
                      value={tagNumber}
                      disabled={isTagNumberExists}
                      onChange={(e) => changeTagNumber(e.target.value)}
                    />
                  </div>}

                  {permissions.hasBadgePermission && <div className="mt-3">
                    <span style={{ color: "#3E4A62" }}>Badge Number</span>
                    <br />

                    <TextField
                      placeholder="Badge Number"
                      sx={{
                        "& legend": { display: "none" },
                        "& fieldset": { top: 0 },
                        fontFamily: "Arial, FontAwesome",
                      }}
                      variant="outlined"
                      size="small"
                      value={badgeNumber}
                      disabled={isBadgeNumberExists}
                      onChange={(e) => changeBadgeNumber(e.target.value)}
                    />
                  </div>}
                </div>

                <DialogActions>
                  <div className="login-help__buttonContainer mt-4">
                    <Button
                      variant="contained"
                      className="login-help-button-cancel mx-2"
                      onClick={handleCheckinDialogClose}
                    >
                      Cancel
                    </Button>
                    <Button
                      variant="contained"
                      className="login-button-request mx-2"
                      onClick={checkinVisitor}
                    >
                      Submit
                    </Button>
                  </div>
                </DialogActions>
              </div>
            </DialogActions>
          </DialogContent>
        </Dialog>

        <div style={{ marginLeft: "10px", padding: "10px", color: "red" }}>
          This tab is for checking visitors in and out (not vendor employees).
          The Get Visitor button will display all visitor names previously
          added. If you don't find a visitor on<br></br> this list, you can add
          a name by selecting the New Visitor button. (Some users will see a
          popup window to enter a tag and/or badge number. After clicking
          "Submit,"<br></br> the name will disappear.)
        </div>
        <Divider
          sx={{
            marginTop: 2,
            marginBottom: 2,
            backgroundColor: "#667085;",
            height: "2px",
          }}
        />
        <div style={{ marginLeft: "15px", marginBottom: "15px" }}>
          <Stack spacing={2} direction="row">
            <TextField
              placeholder="Search"
              sx={{
                "& legend": { display: "none" },
                "& fieldset": { top: 0 },
                fontFamily: "Arial, FontAwesome",
              }}
              variant="outlined"
              size="small"
              onChange={(e) => changeSearchValue(e.target.value)}
            />
            <div style={{ marginLeft: "Auto", padding: "10px" }}>
              <Button
                variant="contained"
                sx={{ padding: "inherit" }}
                onClick={() => handleClickOpen(1)}
              >
                + Add New
              </Button>
            </div>
          </Stack>
        </div>

        <Box sx={{ backgroundColor: "#f8f9fa" }}>
          {loading ? (
            <LoadingSpinner />
          ) : visitors.length > 0 ? (
            <TableContainer component={Paper} sx={{ borderBottom: 0 }}>
              <Table aria-label="customized table">
                <TableHead>
                  <TableRow>
                    <StyledTableCell onClick={() => sortTable("VisitorName")}>
                      <span style={{ color: "#667085", fontSize: "16px" }}>
                        Visitor Name
                      </span>
                      <IconButton>
                        {orderBy.sortingColumn === "VisitorName" ? (
                          orderBy.sortAscending ? (
                            <KeyboardArrowUp />
                          ) : (
                            <KeyboardArrowDown />
                          )
                        ) : (
                          <UnfoldMore />
                        )}
                      </IconButton>
                    </StyledTableCell>
                    <StyledTableCell onClick={() => sortTable("Company")}>
                      <span style={{ color: "#667085", fontSize: "16px" }}>
                        Company
                      </span>
                      <IconButton>
                        {orderBy.sortingColumn === "Company" ? (
                          orderBy.sortAscending ? (
                            <KeyboardArrowUp />
                          ) : (
                            <KeyboardArrowDown />
                          )
                        ) : (
                          <UnfoldMore />
                        )}
                      </IconButton>
                    </StyledTableCell>
                    <StyledTableCell onClick={() => sortTable("SiteContact")}>
                      <span style={{ color: "#667085", fontSize: "16px" }}>
                        Site Contact
                      </span>
                      <IconButton>
                        {orderBy.sortingColumn === "SiteContact" ? (
                          orderBy.sortAscending ? (
                            <KeyboardArrowUp />
                          ) : (
                            <KeyboardArrowDown />
                          )
                        ) : (
                          <UnfoldMore />
                        )}
                      </IconButton>
                    </StyledTableCell>
                    {permissions.hasTagPermission &&
                      <StyledTableCell>
                        <span style={{ color: "#667085", fontSize: "16px" }}>
                          Tag Number
                        </span>
                      </StyledTableCell>
                    }
                    {permissions.hasBadgePermission &&
                      <StyledTableCell>
                        <span style={{ color: "#667085", fontSize: "16px" }}>
                          Badge Number
                        </span>
                      </StyledTableCell>
                    }

                    <StyledTableCell>
                      <span style={{ color: "#667085", fontSize: "16px" }}>
                        Onsite
                      </span>
                    </StyledTableCell>
                    <StyledTableCell>
                      <span style={{ color: "#667085", fontSize: "16px" }}>
                        Offsite
                      </span>
                    </StyledTableCell>
                    <StyledTableCell>
                      <span style={{ color: "#667085", fontSize: "16px" }}>
                        Reset
                      </span>
                    </StyledTableCell>
                    <StyledTableCell>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</StyledTableCell>
                    <StyledTableCell>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</StyledTableCell>
                  </TableRow>
                </TableHead>

                {visitors?.map((r, i) => {

                  const showInfo =
                    i === 0 || r.employeeID !== visitors[i - 1].employeeID;
                  return (
                    <TableBody key={i}>
                      <TableRow key={i}>
                        <StyledTableCell sx={{ width: "17%" }}>
                          {showInfo && (
                            <span>{r.lastName + ", " + r.firstName}</span>
                          )}
                        </StyledTableCell>
                        <StyledTableCell sx={{ width: "15%" }}>
                          {showInfo && (
                            <>
                              <span>{r.company}</span>
                            </>
                          )}
                        </StyledTableCell>

                        <StyledTableCell sx={{ width: "17%" }}>
                          {showInfo && (
                            <>
                              <span>{r.siteContact}</span>
                            </>
                          )}
                        </StyledTableCell>
                        {permissions.hasTagPermission &&
                          <StyledTableCell StyledTableCell sx={{ width: "10%" }}>
                            {/* {showInfo && (<> */}
                            {r.checkin == null ? (
                              <span>{r.tagNumber}</span>
                            ) : (<span>{r.tagNumber}</span>)
                            }
                            {/* </>)} */}
                          </StyledTableCell>
                        }
                        {permissions.hasBadgePermission &&
                          <StyledTableCell sx={{ width: "10%" }}>
                            {/* {showInfo && (<> */}
                            {r.checkin == null ? (
                              <span>{r.badgeNumber}</span>
                            ) : <span>{r.badgeNumber}</span>}
                          </StyledTableCell>
                        }
                        <StyledTableCell sx={{ width: "15%" }}
                        >
                          {r.checkin == null ? (
                            <div
                              style={{ cursor: (r.locked) ? 'not-allowed' : '' }}
                            >
                              <IconButton
                                aria-label="OpenArrow"
                                onClick={() => {
                                  if (!permissions.hasTagPermission && !permissions.hasBadgePermission) {
                                    checkinVisitorDirectly(r.vendorID,
                                      r.employeeID,
                                      r.oldTagId === 0 ? undefined : r.oldTagId,
                                      r.oldBadgeId === 0 ? undefined : r.oldBadgeId);
                                  } else {
                                    handleCheckinOpen(
                                      r.vendorID,
                                      r.employeeID,
                                      r.oldTagId === 0 ? undefined : r.oldTagId,
                                      r.oldBadgeId === 0 ? undefined : r.oldBadgeId
                                    );
                                  }
                                }}
                                disabled={r.locked}
                              >
                                <span>
                                  {" "}
                                  <img
                                    src={RightArrowOpen}
                                    alt="OpenArrow"
                                  />{" "}
                                  <span
                                    style={{
                                      color: "#2A93DB",
                                      fontSize: "initial",
                                    }}
                                  >
                                    Onsite
                                  </span>{" "}
                                </span>
                              </IconButton>
                            </div>
                          ) : (
                            GetfVDateFormate("", "", r.checkin)
                          )}
                        </StyledTableCell>


                        <StyledTableCell sx={{ width: "15%" }}
                        >
                          {r.checkout == null ? (
                            <div
                              style={{ cursor: (r.locked) ? 'not-allowed' : '' }}
                            >
                              <IconButton
                                aria-label="OpenArrow"
                                onClick={() =>
                                  handleCheckoutUser(
                                    r.vendorID,
                                    r.employeeID,
                                    r.onsiteOffsiteID
                                  )
                                }
                                disabled={r.locked}
                              >
                                <span>
                                  {" "}
                                  <img
                                    src={RightArrowOpen}
                                    alt="OpenArrow"
                                  />{" "}
                                  <span
                                    style={{
                                      color: "#2A93DB",
                                      fontSize: "initial",
                                    }}
                                  >
                                    Offsite
                                  </span>{" "}
                                </span>
                              </IconButton>
                            </div>
                          ) : (
                            GetfVDateFormate("", "", r.checkout)
                          )}
                        </StyledTableCell>

                        <StyledTableCell sx={{ width: "20%" }}
                        >
                          <div
                            style={{ cursor: (r.locked || isReseting || (r.checkin === null && r.checkout === null)) ? 'not-allowed' : '' }}
                          >
                            <IconButton
                              aria-label="OpenArrow"
                              onClick={() => {
                                handleResetVisitor(r.onsiteOffsiteID);
                              }}
                              disabled={r.locked || isReseting || (r.checkin === null && r.checkout === null)}
                            >
                              <span>
                                {" "}
                                <img src={Restoreicon} alt="Restoreicon" />{" "}
                                <span
                                  style={{
                                    color: "#2A93DB",
                                    fontSize: "initial",
                                  }}
                                >
                                  Reset
                                </span>{" "}
                              </span>
                            </IconButton>
                          </div>
                        </StyledTableCell>

                        <TableCell sx={{ width: "20%" }}>
                          <IconButton
                            aria-label="edit"
                            onClick={() =>
                              editVisitorDetail(
                                r.firstName,
                                r.lastName,
                                r.company,
                                r.siteContact,
                                r.employeeID
                              )
                            }
                          >
                            <img src={Edit} alt="editicon" />
                          </IconButton>
                        </TableCell>

                        <TableCell sx={{ width: "20%" }}>
                          <IconButton
                            aria-label="delete"
                            onClick={() => {
                              setDeleteDialogOpen(true);
                              setVisitorId(r.employeeID);
                            }}
                          >
                            <img src={Trash} alt="trashicon" />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  );
                })}
              </Table>
            </TableContainer>
          ) : error ? (
            <ErrorAlert message={error} />
          ) : (
            <ErrorAlert severity="warning" message={"No results found!"} />
          )}
        </Box>
      </Card >

      {!loading && visitors?.length > 0 && (
        <Paginator
          count={pageCount}
          page={Number(pageNumber)}
          margin="18px 0px"
          onChange={setPage}
        />
      )
      }
    </>
  );
}
